module.exports = __webpack_public_path__ + "static/media/info_circle_grey.13d567c1.svg";